import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Handler from '../../../Helpers/Handler';
import { reloadWindowToPath } from '../../../Helpers/Utils';

const insuranceProviders = [
    "ACKO",
    "Bajaj Allianz",
    "Chola MS",
    "Digit",
    "Future Generali",
    "HDFC ERGO",
    "ICICI Lombard",
    "IFFCO Tokio",
    "Kotak",
    "Liberty",
    "Magma HDI",
    "National Insurance",
    "Navi",
    "New India Assurance",
    "Oriental Insurance",
    "Raheja QBE",
    "Reliance",
    "Royal Sundaram",
    "SBI General",
    "Shriram",
    "TATA AIG",
    "United India",
    "Universal Sompo",
    "Zuno"
];

const CarVerification = () => {
    const { id } = useParams();

    const [verificationData, setVerificationData] = useState([
        { perHourKm: "12", perHourPrice: "" },
        { perHourKm: "24", perHourPrice: "" },
        { perHourKm: "1000", perHourPrice: "" }
    ]);

    const [insurance, setInsurance] = useState({
        provider_name: "",
        amount: ""
    });

    const [disableButton, setButtonDisable] = useState(false);

    const handleChange = (index, field, value) => {
        if (value === "" || /^\d+$/.test(value)) {
            setVerificationData((prev) => prev.map((item, i) => i === index ? { ...item, [field]: value } : item));
        }
    };

    const handleInsuranceChange = (field, value) => {
        if (field === "amount") {
            if (value === "" || (/^\d+$/.test(value))) {
                setInsurance((prev) => ({
                    ...prev,
                    [field]: value
                }));
            }
        } else {
            setInsurance((prev) => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const verifyCar = async () => {
        for (let i = 0; i < verificationData.length; i++) {
            const price = verificationData[i]?.perHourPrice;
            if (!price || isNaN(price)) {
                toast.error("Each package price must be a valid number.");
                return;
            }
        }

        for (let i = 0; i < verificationData.length - 1; i++) {
            const currentPrice = Number(verificationData[i].perHourPrice);
            const nextPrice = Number(verificationData[i + 1].perHourPrice);

            if (currentPrice > nextPrice) {
                toast.error("Each package price must be less than or equal to the next package price.");
                return;
            }
        }

        if (!insurance.provider_name) {
            toast.error("Please select an insurance provider.");
            return;
        }

        if (!insurance.amount || isNaN(insurance.amount) || Number(insurance.amount) <= 0) {
            toast.error("Please enter a valid insurance amount.");
            return;
        }

        setButtonDisable(true);

        const payload = {
            packages: verificationData.map((item) => ({
                ...item,
                perHourPrice: Number(item.perHourPrice)
            })),
            insurance: {
                provider_name: insurance.provider_name,
                amount: Number(insurance.amount)
            }
        };

        const response = await Handler({
            method: "PATCH",
            url: `/staff/car/verify/${id}`,
            data: payload
        });

        if (response?.success) {
            toast.success("Car verified successfully!");

            setTimeout(() => {
                reloadWindowToPath(`/car/details/${id}`);
            }, 1500);
        } else {
            setButtonDisable(false);
            toast.error(response?.data?.message || "Something went wrong");
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h5 className="text-center">Pricing Details</h5>
                    <table className="table-bg" style={{ height: "auto", width: "100%", textAlign: "center" }} >
                        <tbody>
                            {verificationData.map((value, i) => (
                                <tr key={i}>
                                    <td className="text-center p-2"> {value.perHourKm !== "1000" ? value.perHourKm : "Unlimited"}{" "} KM </td>

                                    <td className="text-center p-2">
                                        <input
                                            type="text"
                                            placeholder="Price"
                                            className="form-control"
                                            disabled={disableButton}
                                            value={value.perHourPrice}
                                            autoComplete='off'
                                            onChange={(e) => handleChange(i, "perHourPrice", e.target.value)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="col-6">
                    <h5 className="text-center">Insurance Details</h5>

                    <div className="mb-3">
                        <label htmlFor="provider_name" className="form-label">
                            Provider Name
                        </label>

                        <select
                            id="provider_name"
                            className="form-select"
                            disabled={disableButton}
                            value={insurance.provider_name}
                            onChange={(e) => handleInsuranceChange("provider_name", e.target.value)}
                        >
                            <option value="">Select Provider</option>

                            {insuranceProviders.map((provider) => (
                                <option key={provider} value={provider}>
                                    {provider}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="insuranceAmount" className="form-label">
                            Insurance Amount
                        </label>

                        <div className="input-group">
                            <span className="input-group-text">₹</span>

                            <input
                                type="text"
                                id="insuranceAmount"
                                className="form-control"
                                placeholder="Enter insurance amount"
                                disabled={disableButton}
                                value={insurance.amount}
                                autoComplete='off'
                                onChange={(e) => handleInsuranceChange("amount", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-center mt-3">
                <button
                    className="btn btn-success"
                    onClick={verifyCar}
                    disabled={disableButton}
                >
                    {disableButton ? "Verifying..." : "Verify Car"}
                </button>
            </div>
        </>
    );
};

export default CarVerification;